module.exports = __webpack_public_path__ + "static/img/data-center-3.1d50c948.png";